import { eachDayOfInterval, startOfMonth, endOfMonth } from "date-fns";

export const weekdays = ["P", "U", "S", "C", "P", "S", "N"];

export const months = [
  "JANUAR",
  "FEBRUAR",
  "MART",
  "APRIL",
  "MAJ",
  "JUN",
  "JUL",
  "AVGUST",
  "SEPTEMBAR",
  "OKTOBAR",
  "NOVEMBAR",
  "DECEMBAR",
];

export const setDays = (selected) => {
  const startDay = startOfMonth(selected);
  const endDay = endOfMonth(selected);

  return eachDayOfInterval({
    start: startDay,
    end: endDay,
  });
};

export const currentDate = new Date(new Date().setHours(0, 0, 0, 0));



